// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const AlgalOmegaD3 = {
  productCode: "SBPNVZ-D3",
  productName: "Algal Omega D3",
  ingredients: "Algae",
  overview:"Algal Omega D3 is a Natural & Standardized extract blend of algal biomass",
  assay:" Natural Cholecalciferol 100000 IU",
  coNutrients:"Secondary metabolites include triacylglycerol, EPA, PUFA, polyphenols, Vitamin E, Folate and Vitamin B12 (not a claim)",
  studies:" Comprehensive Stability studies, ongoing studies to understand the medicinal benefits that has not been reported.",
  benefits:"Eco-sustainable and can replace fishery products for protein and lipid nutrition. Bioactive polyamines play key roles in multiple cellular functions. Carotenoids help prevent metabolic, aging  and degenerative pathologies affecting the eye. Xanthophyll-complex can improve cardiovascular health",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/AlgalOmegaD3/AOD-1.png",
    "images/Portfolio/OrgavitazForDeficiencies/AlgalOmegaD3/AOD-2.png",


  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default AlgalOmegaD3;
